<form
  novalidate=""
  (ngSubmit)="onFormSubmit($event)"
  class="lg:h-full flex flex-col"
>
  <!-- Form Content Starts -->
  <div class="form flex-1 flex flex-col mb-5 lg:mb-0">
    <ng-container [ngSwitch]="currentState">
      <!-- Guidelines -->
      <ng-container *ngSwitchCase="CurrentState.Guidelines">
        <div>
          <ng-container *ngTemplateOutlet="guidelines"></ng-container>
          <div class="flex flex-col gap-2">
            <label class="text-sm my-6">
              {{ 'videoOpenEnded.disclaimer' | translate }}
              <a
                href="https://www.suzy.com/external-audiences-privacy-notice"
                class="text-blue-dark pointer-events-cursor"
              >
                {{ 'videoOpenEnded.privacyPolicy' | translate }}
              </a>
              <span> {{ 'surveyPreview.and' | translate }} </span>
              <a
                href="/biometric-data-policy"
                class="text-blue-dark pointer-events-cursor"
              >
                {{ 'videoOpenEnded.videoFAQ' | translate }}
              </a>
            </label>
            <!-- Agree radio button -->

            <label
              for="agreeRadio"
              class="flex items-center leading-normal"
              tabindex="0"
            >
              <input
                class="sr-only"
                name="agreement"
                type="radio"
                [checked]="hasGivenGuidelinesAnswer && hasAgreedToGuidelines"
                id="agreeRadio"
                (change)="onGuidelinesRespond(true, true)"
                required
              />
              <div
                *ngIf="!hasGivenGuidelinesAnswer || !hasAgreedToGuidelines"
                class="radio-btn w-6 h-6 border-2 rounded-full min-w-6 border-gray mr-4 ltr:mr-4 rtl:ml-4"
              ></div>
              <div
                *ngIf="hasGivenGuidelinesAnswer && hasAgreedToGuidelines"
                class="radio-btn flex items-center justify-center w-6 h-6 rounded-full min-w-6 bg-blue-dark mr-4 ltr:mr-4 rtl:ml-4"
              >
                <span class="text-xs text-white fa fa-check"></span>
              </div>
              <div
                class="radio-label text-base font-semibold md:text-sm"
                id="agreeRadioLabelContainer"
              >
                {{ 'videoOpenEnded.agree' | translate }}
                <span class="radio-icon"></span>
              </div>
            </label>
            <!-- Disagree radio button -->
            <label
              for="disagreeRadio"
              class="flex items-center leading-normal"
              tabindex="0"
            >
              <input
                class="sr-only"
                name="agreement"
                type="radio"
                [checked]="hasGivenGuidelinesAnswer && !hasAgreedToGuidelines"
                id="disagreeRadio"
                (change)="onGuidelinesRespond(false, true)"
                required
              />
              <div
                *ngIf="!hasGivenGuidelinesAnswer || hasAgreedToGuidelines"
                class="radio-btn w-6 h-6 border-2 rounded-full min-w-6 border-gray mr-4 ltr:mr-4 rtl:ml-4"
              ></div>
              <div
                *ngIf="hasGivenGuidelinesAnswer && !hasAgreedToGuidelines"
                class="radio-btn flex items-center justify-center w-6 h-6 rounded-full min-w-6 bg-blue-dark mr-4 ltr:mr-4 rtl:ml-4"
              >
                <span class="text-xs text-white fa fa-check"></span>
              </div>
              <div
                class="radio-label text-base font-semibold md:text-sm"
                id="disagreeRadioLabelContainer"
              >
                {{ 'videoOpenEnded.disagree' | translate }}
                <span class="radio-icon"></span>
              </div>
            </label>

            <ng-container
              *ngTemplateOutlet="
                errorTemplate;
                context: { message: guidelinesError }
              "
            ></ng-container>
          </div>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="CurrentState.Permissions">
        <div class="flex flex-col items-center justify-center py-8 text-center">
          <div class="flex flex-row items-center justify-center gap-4 mb-6">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="41"
              height="40"
              viewBox="0 0 41 40"
              fill="none"
            >
              <path
                d="M28.8333 17.5V11.6667C28.8333 10.75 28.0833 10 27.1667 10H7.16667C6.25 10 5.5 10.75 5.5 11.6667V28.3333C5.5 29.25 6.25 30 7.16667 30H27.1667C28.0833 30 28.8333 29.25 28.8333 28.3333V22.5L32.65 26.3167C33.7 27.3667 35.5 26.6167 35.5 25.1333V14.85C35.5 13.3667 33.7 12.6167 32.65 13.6667L28.8333 17.5Z"
                fill="white"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="41"
              height="40"
              viewBox="0 0 41 40"
              fill="none"
            >
              <path
                d="M30.6329 19.1667C31.4994 19.1667 32.1662 19.9331 32.0499 20.783C31.2832 25.733 27.0994 29.6503 22.1661 30.3669V34.1667C22.1661 35.0834 21.4166 35.8336 20.5001 35.8337C19.5834 35.8337 18.8331 35.0834 18.8331 34.1667V30.3669C13.8831 29.6169 9.71691 25.7329 8.95025 20.783C8.83385 19.9332 9.49986 19.1669 10.3663 19.1667C11.0496 19.1667 11.6501 19.667 11.7501 20.3503C12.3668 24.7169 16.2835 27.6667 20.5001 27.6667C24.7166 27.6667 28.6333 24.7002 29.2501 20.3503C29.35 19.6671 29.933 19.1669 30.6329 19.1667ZM20.5001 4.16675C23.2666 4.16685 25.5001 6.40015 25.5001 9.16675L25.4835 19.1667C25.4835 21.9333 23.2666 24.1666 20.5001 24.1667C17.7334 24.1667 15.5001 21.9334 15.5001 19.1667V9.16675C15.5001 6.40008 17.7334 4.16675 20.5001 4.16675Z"
                fill="white"
              />
            </svg>
          </div>
          <div class="mb-4 text-lg font-semibold" *ngIf="!isPreviewApp">
            {{ 'videoOpenEnded.permissionTitle' | translate }}
          </div>
          <div class="mb-4 text-lg font-semibold" *ngIf="isPreviewApp">
            {{ 'videoOpenEnded.permissionTitlePreview' | translate }}
          </div>
          <div
            class="text-sm font-normal text-light-black dark:text-white"
            *ngIf="!isPreviewApp"
          >
            {{ 'videoOpenEnded.permissionSubtitle1' | translate }}
          </div>
          <div
            class="text-sm font-normal text-light-black dark:text-white"
            *ngIf="isPreviewApp"
          >
            {{ 'videoOpenEnded.permissionSubtitle1Preview' | translate }}
          </div>
          <div class="text-sm font-normal text-light-black dark:text-white">
            {{ 'videoOpenEnded.permissionSubtitle2' | translate }}
          </div>
          <button
            type="button"
            class="px-6 py-2 bg-transparent text-blue-dark rounded-full mt-6 border-2 border-blue-dark font-semibold"
            (click)="requestMediaPermissions()"
          >
            {{ 'videoOpenEnded.askForPermission' | translate }}
          </button>
        </div>
      </ng-container>
      <!-- Choose Devices -->
      <ng-container *ngSwitchCase="CurrentState.ChooseDevices">
        <div class="mb-4 flex flex-col md:flex-row items-start gap-6">
          <div class="w-full">
            <video
              *ngIf="selectedAudioDeviceId && selectedVideoDeviceId"
              #liveCamera
              class="video w-96 h-80 mx-auto rounded-lg"
              autoplay
              playsinline
              muted
            ></video>
            <div
              *ngIf="!selectedVideoDeviceId"
              class="flex items-center justify-center w-96 h-80 bg-light-gray-3 rounded-lg mx-auto"
            >
              <div class="p-4 bg-body-dark rounded-lg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="41"
                  height="41"
                  viewBox="0 0 41 41"
                  fill="none"
                >
                  <path
                    d="M20.4998 23.8337C24.9496 23.8337 33.8333 26.0666 33.8337 30.4998V32.1667C33.8337 33.0834 33.0834 33.8337 32.1667 33.8337H8.83374C7.91707 33.8337 7.16675 33.0834 7.16675 32.1667V30.4998C7.16718 26.0667 16.0498 23.8338 20.4998 23.8337ZM20.4998 7.16675C24.1831 7.16675 27.1667 10.1504 27.1667 13.8337C27.1666 17.5169 24.183 20.4998 20.4998 20.4998C16.8167 20.4996 13.8339 17.5168 13.8337 13.8337C13.8337 10.1505 16.8166 7.16692 20.4998 7.16675Z"
                    fill="white"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div class="flex flex-col gap-4 w-full">
            <div class="custom-select relative">
              <span
                *ngIf="selectedVideoDeviceId"
                class="absolute inset-y-0 left-2 top-2 flex items-center justify-center pointer-events-none"
                style="z-index: 2"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M11.3333 7V4.66667C11.3333 4.3 11.0333 4 10.6667 4H2.66667C2.3 4 2 4.3 2 4.66667V11.3333C2 11.7 2.3 12 2.66667 12H10.6667C11.0333 12 11.3333 11.7 11.3333 11.3333V9L12.86 10.5267C13.28 10.9467 14 10.6467 14 10.0533V5.94C14 5.34667 13.28 5.04667 12.86 5.46667L11.3333 7Z"
                    fill="white"
                  />
                </svg>
              </span>
              <select
                [disabled]="isPreviewApp"
                name="videoDevices"
                class="video-device-select block w-full p-2 mt-2 border rounded-md text-light-black dark:text-white bg-input dark:bg-black-light border-active-link dark:border-active-link-dark"
                [(ngModel)]="selectedVideoDeviceId"
                (change)="onVideoDeviceChange()"
                [ngModelOptions]="{ standalone: true }"
                [style.paddingLeft]="'2.2rem'"
              >
                <option
                  *ngFor="let device of availableVideoDevices"
                  [value]="device.deviceId"
                >
                  {{ device.label || 'Camera ' + device.deviceId }}
                </option>
              </select>
            </div>
            <div class="custom-select relative">
              <span
                *ngIf="selectedAudioDeviceId"
                class="absolute inset-y-0 left-2 top-5 flex items-start pointer-events-none"
                style="z-index: 2"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M12.0534 7.66675C12.3999 7.66679 12.6663 7.97331 12.6198 8.31323C12.3131 10.2932 10.64 11.8605 8.66665 12.1472V13.6667C8.66665 14.0334 8.36632 14.3337 7.99965 14.3337C7.63313 14.3336 7.33364 14.0333 7.33364 13.6667V12.1472C5.35364 11.8472 3.6862 10.2932 3.37954 8.31323C3.33303 7.97333 3.60033 7.66675 3.94692 7.66675C4.22013 7.66689 4.45967 7.86714 4.49965 8.14038C4.74642 9.8868 6.31319 11.067 7.99965 11.0671C9.68621 11.0671 11.2528 9.8802 11.4997 8.14038C11.5397 7.86705 11.7734 7.66675 12.0534 7.66675ZM7.99965 1.66675C9.10632 1.66675 9.99965 2.56008 9.99965 3.66675L9.99282 7.66675C9.99282 8.77341 9.10632 9.66675 7.99965 9.66675C6.89313 9.66658 5.99965 8.77331 5.99965 7.66675V3.66675C5.99965 2.56019 6.89313 1.66692 7.99965 1.66675Z"
                    fill="white"
                  />
                </svg>
              </span>
              <select
                [disabled]="isPreviewApp"
                name="audioDevices"
                class="audio-device-select block w-full p-2 mt-2 border rounded-md text-light-black dark:text-white bg-input dark:bg-black-light border-active-link dark:border-active-link-dark"
                [(ngModel)]="selectedAudioDeviceId"
                (change)="onAudioDeviceChange()"
                [ngModelOptions]="{ standalone: true }"
                [style.paddingLeft]="'2.2rem'"
              >
                <option
                  *ngFor="let device of availableAudioDevices"
                  [value]="device.deviceId"
                >
                  {{ device.label || 'Microphone ' + device.deviceId }}
                </option>
              </select>
              <!-- Add vertical padding above the audio level bar -->
              <div class="pt-3">
                <div
                  class="audio-level-bar w-full mt-2"
                  role="progressbar"
                  [attr.aria-valuenow]="audioLevel"
                  aria-valuemin="0"
                  aria-valuemax="1"
                >
                  <div
                    *ngIf="audioLevel !== undefined"
                    [ngStyle]="{ width: audioLevel * 100 + '%' }"
                    class="audio-level-fill"
                  ></div>
                </div>
              </div>
              <!-- Microphone check label -->
              <div
                class="microphone-check-label pt-2"
                [ngClass]="{ success: hasDetectedMicrophone }"
              >
                <ng-container *ngIf="!hasDetectedMicrophone">
                  <div class="text-light-black dark:text-white">
                    {{
                      'videoOpenEnded.microphoneCheckNotDetected' | translate
                    }}
                  </div>
                </ng-container>
                <ng-container *ngIf="hasDetectedMicrophone">
                  <div class="flex items-center">
                    <svg
                      class="mr-3"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M14.72 8.78972L10.43 13.0897L8.77998 11.4397C8.53559 11.1543 8.15187 11.03 7.78656 11.1179C7.42126 11.2058 7.13605 11.491 7.04817 11.8563C6.9603 12.2216 7.08461 12.6053 7.36998 12.8497L9.71998 15.2097C9.9087 15.3969 10.1642 15.5013 10.43 15.4997C10.6923 15.4986 10.9437 15.3945 11.13 15.2097L16.13 10.2097C16.3193 10.022 16.4258 9.76636 16.4258 9.49972C16.4258 9.23308 16.3193 8.97749 16.13 8.78972C15.7399 8.402 15.11 8.402 14.72 8.78972ZM12 1.99976C6.47715 1.99976 2 6.47691 2 11.9998C2 17.5226 6.47715 21.9998 12 21.9998C17.5228 21.9998 22 17.5226 22 11.9998C22 9.34759 20.9464 6.80405 19.0711 4.92869C17.1957 3.05332 14.6522 1.99976 12 1.99976ZM12 19.9996C7.58174 19.9996 4.00002 16.4179 4.00002 11.9996C4.00002 7.58135 7.58174 3.99963 12 3.99963C16.4183 3.99963 20 7.58135 20 11.9996C20 14.1214 19.1572 16.1562 17.6569 17.6565C16.1566 19.1568 14.1217 19.9996 12 19.9996Z"
                        fill="#68C97F"
                      />
                    </svg>
                    <div class="flex flex-col font-semibold">
                      <span>{{
                        'videoOpenEnded.microphoneCheckDetectedSubtitle1'
                          | translate
                      }}</span>
                      <span>{{
                        'videoOpenEnded.microphoneCheckDetectedSubtitle2'
                          | translate
                      }}</span>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
            <ng-container
              *ngTemplateOutlet="
                errorTemplate;
                context: { message: cameraError }
              "
            ></ng-container>
          </div>
        </div>
      </ng-container>
      <!-- Review State -->
      <ng-container *ngSwitchCase="CurrentState.Review">
        <div
          class="flex-col lg:flex-row gap-6 flex justify-between py-8 items-start text-center lg:gap-2"
        >
          <div
            class="relative flex items-center justify-end flex-grow flex-col"
          >
            <video
              *ngIf="!isPreviewApp"
              class="review-video-player"
              muted
              #reviewVideoPlayer
              [src]="downloadUrl"
              [autoplay]="false"
              [controls]="false"
            ></video>
            <img
              *ngIf="isPreviewApp"
              class="review-video-player"
              src="./assets/img/voe-placeholder.png"
              alt="Video preview placeholder"
            />
            <button
              (click)="onReviewVideoPlay()"
              type="button"
              class="absolute review-video-player-play-btn"
              *ngIf="!isPreviewApp"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="64"
                height="62"
                viewBox="0 0 64 62"
                fill="none"
              >
                <g filter="url(#filter0_d_3709_32700)">
                  <path
                    d="M23.6455 13.6279V40.3722L45.2662 27.0001L23.6455 13.6279Z"
                    fill="white"
                  />
                  <path
                    d="M31.7803 2C46.0725 2 57.5605 13.2462 57.5605 27C57.5605 40.7538 46.0725 52 31.7803 52C17.4881 52 6 40.7538 6 27C6 13.2462 17.4881 2.00004 31.7803 2Z"
                    stroke="white"
                    stroke-width="4"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_d_3709_32700"
                    x="0"
                    y="0"
                    width="63.5608"
                    height="62"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_3709_32700"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_3709_32700"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
            </button>
            <div class="review-video-controls h-16 w-80 flex">
              <div
                class="flex items-center w-100 border flex-col justify-center bg-white flex-grow text-black"
              >
                <button
                  [disabled]="isPreviewApp"
                  (click)="onDeleteReviewVideo()"
                  type="button"
                  class="icon-btn"
                  aria-label="Delete video"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="currentColor"
                  >
                    <path
                      d="M18.7999 7V19C18.7999 20.1 17.8999 21 16.7999 21H8.79993C7.69993 21 6.79993 20.1 6.79993 19V7H18.7999ZM8.79993 9V19H16.7999V9H8.79993ZM16.2999 4H19.7999V6H5.79993V4H9.29993L10.2999 3H15.2999L16.2999 4Z"
                      fill="currentColor"
                    />
                  </svg>
                </button>
                <label for="delete">{{
                  'videoOpenEnded.delete' | translate
                }}</label>
              </div>
              <div
                class="flex flex-col w-100 items-center justify-center border flex-grow bg-white text-black"
              >
                <button
                  (click)="onRetakeReviewVideo()"
                  [disabled]="isPreviewApp"
                  type="button"
                  class="icon-btn"
                  aria-label="Retake video"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="currentColor"
                  >
                    <path
                      d="M16.8 6C17.35 6 17.8 6.45 17.8 7V10.5L21.8 6.5V17.5L17.8 13.5V17C17.8 17.55 17.35 18 16.8 18H4.80005C4.25005 18 3.80005 17.55 3.80005 17V7C3.80005 6.45 4.25005 6 4.80005 6H16.8ZM5.80005 8V16H15.8V8H5.80005Z"
                      fill="currentColor"
                    />
                  </svg>
                </button>
                <label>{{ 'videoOpenEnded.retake' | translate }}</label>
              </div>
            </div>
          </div>
          <div class="flex-grow flex items-start justify-start flex-col">
            <ng-container *ngTemplateOutlet="guidelines"></ng-container>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
  <div
    class="relative flex items-center justify-center space-x-2 align-middle mt-auto"
  >
    <!-- Hide skip/continue/submit in 'permissions' state -->
    <ng-container *ngIf="currentState !== CurrentState.Permissions">
      <!-- Show skip button in 'guidelines' state -->
      <button
        class="w-36 text-blue-dark skip"
        (click)="onFormSkip($event)"
        data-track="member-open-ended-skip"
        *ngIf="
          currentState === CurrentState.Guidelines &&
          !disableSkip &&
          !isSpecialMission
        "
        [ngClass]="{ loading: isSkipping }"
        [disabled]="isSkipping"
      >
        <span class="btn-label"> {{ 'general.skip' | translate }}</span>
        <span class="dot dot-1"></span>
        <span class="dot dot-2"></span>
        <span class="dot dot-3"></span>
      </button>
      <button
        class="animation-submit-btn {{
          isSpecialMission ? 'specialMission' : ''
        }}"
        [ngClass]="submitButtonClasses"
        (click)="onSubmitClick()"
        data-track="member-open-ended-submit"
        [disabled]="isSkipping || isSubmitting || isLoading"
        [type]="isReadyToSubmit ? 'submit' : 'button'"
      >
        <!-- Show "Continue" for Guidelines or ChooseDevices, "Submit" for Review, else fallback to Continue -->
        <div class="primaryTitle text">
          {{ submitButtonLabel | translate }}
        </div>
        <div class="loadingTitle text">
          <suzy-spinner
            class="absolute left-0 right-0 button-spinner"
            [ngClass]="!isSpecialMission ? 'top-3' : 'top-0.5'"
            size="small"
            [button]="true"
            [round]="'7'"
            [color]="'#ffffff'"
            [overlay]="false"
          >
          </suzy-spinner>
        </div>
        <div class="successTitle text">
          <svg class="animated-check" viewBox="0 0 24 24">
            <path d="M4.1 12.7L9 17.6 20.3 6.3" fill="none" />
          </svg>
        </div>
      </button>
    </ng-container>
  </div>

  <!-- Form Content Ends -->
</form>

<ng-template #guidelines>
  <p class="text-sm font-medium leading-normal text-left">
    {{ 'videoOpenEnded.guidelinesTitle' | translate }}
  </p>
  <ul class="text-sm font-medium leading-normal text-left list-disc pl-4">
    <li>
      <label>{{ 'videoOpenEnded.guideline1' | translate }}</label>
    </li>
    <li>
      <label>{{ 'videoOpenEnded.guideline2' | translate }}</label>
    </li>
    <li>
      <label>{{ 'videoOpenEnded.guideline3' | translate }}</label>
    </li>
    <li>
      <label>{{ 'videoOpenEnded.guideline4' | translate }}</label>
    </li>
    <li>
      <label>{{ 'videoOpenEnded.guideline5' | translate }}</label>
    </li>
    <li>
      <label>{{ 'videoOpenEnded.guideline6' | translate }}</label>
    </li>
    <li>
      <label>{{ 'videoOpenEnded.guideline7' | translate }}</label>
    </li>
  </ul>
</ng-template>

<ng-template #errorTemplate let-message="message">
  <p *ngIf="message" class="flex items-center my-3 error-inline-msg text-error">
    <svg
      class="inline-block mr-2"
      width="24"
      height="24"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style="flex-shrink: 0"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.50004 4.04351C8.06282 4.04351 7.70837 4.39795 7.70837 4.83518V8.00185C7.70837 8.43907 8.06282 8.79351 8.50004 8.79351C8.93727 8.79351 9.29171 8.43907 9.29171 8.00185V4.83518C9.29171 4.39795 8.93727 4.04351 8.50004 4.04351ZM9.22837 10.8677C9.21104 10.8173 9.18708 10.7694 9.15712 10.7252L9.06212 10.6065C8.83447 10.3818 8.49402 10.3163 8.1992 10.4402C8.10326 10.4803 8.0149 10.5366 7.93795 10.6065C7.78976 10.7559 7.70715 10.9581 7.70837 11.1686C7.70962 11.272 7.73114 11.3742 7.7717 11.4694C7.84368 11.6683 8.00031 11.8249 8.1992 11.8969C8.39082 11.9816 8.60925 11.9816 8.80087 11.8969C8.99976 11.8249 9.15639 11.6683 9.22837 11.4694C9.26894 11.3742 9.29045 11.272 9.2917 11.1686C9.29559 11.1159 9.29559 11.0629 9.2917 11.0102C9.27807 10.9597 9.25671 10.9117 9.22837 10.8677ZM8.50004 0.0852051C4.12779 0.0852051 0.583374 3.62962 0.583374 8.00187C0.583374 12.3741 4.12779 15.9185 8.50004 15.9185C12.8723 15.9185 16.4167 12.3741 16.4167 8.00187C16.4167 5.90224 15.5826 3.88861 14.098 2.40394C12.6133 0.91928 10.5997 0.0852051 8.50004 0.0852051ZM8.50005 14.3352C5.00225 14.3352 2.16672 11.4996 2.16672 8.00185C2.16672 4.50404 5.00225 1.66851 8.50005 1.66851C11.9979 1.66851 14.8334 4.50404 14.8334 8.00185C14.8334 9.68155 14.1661 11.2925 12.9784 12.4802C11.7907 13.6679 10.1798 14.3352 8.50005 14.3352Z"
        fill="#FF5F57"
      />
    </svg>
    {{ message | translate }}
  </p>
</ng-template>
